import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac875ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-details" }
const _hoisted_2 = { class: "user-details-company" }
const _hoisted_3 = { class: "user-details-name" }

import { Dropdown } from 'floating-vue'
import CompanyAvatar from '@/layouts/AppLayoutHeader/CompanyAvatar.vue'
import { computed, onMounted, ref } from 'vue'
import { getStateData } from '@/store/getters'
import LanguageDropdown from '@/layouts/AppLayoutHeader/components/LanguageDropdown.vue'
import DropdownMenuItem from '@/layouts/AppLayoutHeader/components/DropdownMenuItem.vue'
import { logout } from '@/store/logoutActions'
import { useRouter } from 'vue-router'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { analytics } from '@/services/analyticsProvider'
import { CarrierVettingStatus } from '@sennder/carrier-profile-public-axios-client'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {

const $router = useRouter()

const companyName = computed(() => getStateData().company?.name || '')
const userName = computed(() => getStateData().profile?.name || '')
const isCarrierUnVetted = ref(false)

onMounted(async () => {
  isCarrierUnVetted.value =
    getStateData().cpsCarrier?.vetting_status === CarrierVettingStatus.Unvetted
})

const redirectToProfile = async () => {
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_COMPANY_PROFILE_CLICK)
  const route = {
    name: 'Profile',
    query: { page: 'rating' },
  }
  await $router.push(route)
}

const redirectToInviteTab = async () => {
  analytics.trackEvent(ANALYTICS_EVENTS.INVITE_TEAM_MEMBER)
  const route = {
    name: 'Profile',
    query: { page: 'team', inviteFormExpanded: 'true' },
  }
  await $router.push(route)
}

let isLoggingOut = false

const onLogout = async () => {
  if (isLoggingOut) {
    // it's been clicked before
    return
  }
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_LOGOUT_CLICK)
  isLoggingOut = true
  try {
    await logout({ callBackend: true, calledByUser: true })
  } finally {
    isLoggingOut = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), {
    onShow: _cache[1] || (_cache[1] = ($event: any) => (_unref(analytics).trackEvent(_unref(ANALYTICS_EVENTS).MENU_PROFILE_CLICK)))
  }, {
    popper: _withCtx(() => [
      _createVNode(DropdownMenuItem, {
        onClick: redirectToProfile,
        "text-mode": false,
        disabled: isCarrierUnVetted.value
      }, {
        before: _withCtx(() => [
          _createVNode(CompanyAvatar)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(companyName.value), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_3, _toDisplayString(userName.value), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(LanguageDropdown, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(analytics).trackEvent(_unref(ANALYTICS_EVENTS).MENU_LANGUAGE_CLICK)))
      }),
      _createVNode(DropdownMenuItem, {
        onClick: redirectToInviteTab,
        icon: "users-icon",
        disabled: isCarrierUnVetted.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('sidebar.usermenu.inviteTeamMember')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(DropdownMenuItem, {
        onClick: onLogout,
        icon: "log-out-icon",
        "data-test": "orcas-migration-logout-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('sidebar.logout')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      _createVNode(CompanyAvatar)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})